import React, { useEffect, useState } from 'react'

import { DndProvider, useDrag, useDrop } from "react-dnd";
import _ from 'lodash';
import cx from 'classnames';

import SortableTreeItem from './sortableItem';

import styles from '../menuList.module.scss';

const SortableTree = ({ menuContent, contentList, parent, onChangeName, onChangeAction, widgetId, editorSession, moveCard, findItem, show }) => {

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: "menu",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    hover(item, monitor) {
      const { id: draggedId } = monitor.getItem()

      if (!monitor.isOver({ shallow: true })) return

      const descendantNode = findItem(parent, menuContent)
      const dragItem = findItem(draggedId, contentList);

      if (descendantNode || draggedId === parent) return
      if(_.size(dragItem.children) > 0) return

      moveCard(draggedId, null, parent)
    }
  });

  const renderCard = (content, index) => {
    return (
      <SortableTreeItem
        key={content.uid}
        index={index}
        parent={parent}
        id={content.uid}
        onChangeName={onChangeName}
        onChangeAction={onChangeAction}
        widgetId={widgetId}
        editorSession={editorSession}
        content={content}
        menuContent={menuContent}
        contentList={contentList}
        moveCard={moveCard}
        findItem={findItem}
      />
    )
  }

  return (
    <div
      ref={drop}
      className={cx(styles.listContainer, { [styles.dropDownList]: parent }, { [styles.expandList]: show })}
    >
      {show &&
        menuContent.map((content, index) => renderCard(content, index))
      }
    </div>
  );
}

export default SortableTree